<template>
    <div class="sing-up-form">
        <h1>Create a Shop</h1>
        <form class="form" @submit.prevent="onSubmit">
            <template v-for="key in form.fieldKeys" :key="key">
                <FormItem v-bind="form.items[key].props" :name="key">
                    <component
                        :is="form.items[key].component"
                        :name="key"
                        :appendText="key === 'title' ? `${this.form.items.title.value}.runshop.io` : null"
                        v-model="form.items[key].value"
                        v-bind="form.items[key].props"
                        @update-field="onUpdateFieldValue"
                    />
                </FormItem>
            </template>
            <div class="form-button">
                <Button> {{ $t('template.signUp.buttons.register') }}</Button>
            </div>
            <div class="form__note">
                <i18n-t keypath="template.signUp.agreement" tag="span">
                    <template #termsAndConditions>
                        <router-link to="/">Terms and Conditions</router-link>
                    </template>
                    <template #privacy>
                        <router-link to="/">Privacy Policy</router-link>
                    </template>
                    <template #login>
                        <router-link :to="{ name: 'Login' }">Log in</router-link>
                    </template>
                </i18n-t>
                <br />
                <i18n-t keypath="template.signUp.login" tag="span">
                    <template #login>
                        <router-link :to="{ name: 'Login' }">Log in</router-link>
                    </template>
                </i18n-t>
                <br />
                <i18n-t keypath="template.signUp.createQuestion" tag="span">
                    <template #entity>
                        account without a shop?
                        <router-link :to="{ name: 'Create account' }">Create account</router-link>
                    </template>
                </i18n-t>
            </div>
        </form>
    </div>
</template>

<script>
import Form from '@/entities/form';
import validateField from '@/entities/validator';
import FormItem from '@/components/form/item.vue';
import FormError from '@/components/form/error.vue';
import InputText from '@/components/form/controls/inputText.vue';
import InputPassword from '@/components/form/controls/inputPassword.vue';
import Button from '@/components/common/button.vue';
import RegisterService from '@/services/RegisterService.ts';
import { mapActions } from 'vuex';

export default {
    name: 'SignUpForm',
    components: {
        FormItem,
        FormError,
        InputText,
        InputPassword,
        Button,
    },
    data() {
        return {
            form: new Form({
                action: this.formAction,
                validateHandler: this.validateHandler,
                successHandler: this.successHandler,
                failedHandler: this.failedHandler,
                items: {
                    title: {
                        value: '',
                        type: 'field',
                        component: 'input-text',
                        props: {
                            rules: ['noEmpty'],
                            label: this.$t('template.signUp.fields.title'),
                        },
                    },
                    email: {
                        value: '',
                        type: 'field',
                        component: 'input-text',
                        props: {
                            rules: ['email', 'noEmpty'],
                            label: this.$t('template.signUp.fields.email'),
                        },
                    },
                    password: {
                        value: '',
                        type: 'field',
                        component: 'input-password',
                        props: {
                            rules: ['noEmpty'],
                            label: this.$t('template.signUp.fields.password'),
                        },
                    },
                    /*              promoCode: {
                        value: '',
                        type: 'field',
                        component: 'input-text',
                        props: {
                            rules: [],
                            label: this.$t('template.signUp.fields.referral'),
                            hasSpoiler: true,
                        },
                    },*/
                },
            }),
        };
    },
    methods: {
        ...mapActions('auth', {
            setInstanceId: 'setInstanceId',
            setEmail: 'setEmail',
        }),
        formAction(formData) {
            console.log('send', formData);
            return RegisterService.register(formData);
        },
        validateHandler(isValid) {
            console.log('validateHandler', isValid);
        },
        successHandler(result) {
            console.log('successHandler', result);
            const items = this.form.items;
            localStorage.setItem('instanceId', items.title.value);
            localStorage.setItem('isNewUser', true);
            this.setEmail(items.email.value);
            this.$router.push({ name: 'Verification' });
        },
        failedHandler(response) {
            console.log('failedHandler', response);
        },
        onSubmit() {
            this.form.submit();
        },
        onUpdateFieldValue(payload) {
            const { name } = payload;
            const item = this.form.items[name];
            item.props.errors = validateField(item.value, item.props.rules);
        },
    },
};
</script>

<style lang="scss">
.sing-up-form {
    display: block;
    width: 100%;
    h1 {
        margin-top: 0;
        font-size: 32px;
        margin-bottom: 20px;
    }
}
</style>
